<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">PROGRAM & BUDGETING</span>
                <span v-else>PROGRAM & BUDGETING</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Program & Budgeting</span>
                    <span v-else>Program & Budgeting</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        Monitoring Proyek
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        Project Monitoring
                    </h1>
                </div>
                <p class="mb-0" v-if="(bahasa === null) || (bahasa == 'ina')">
                    Tanggal Integrasi Data (PMIS, LMS & E-mon): {{ G_formatDate(tanggalsinkron) }}
                    <br>Tanggal Data Monev PMC: {{ G_formatDateNonWIB(tanggaldatamonev) }}
                </p>
                <p class="mb-0" v-else>
                    Data Integration Date (PMIS, LMS & E-mon): {{ G_formatDateEng(tanggalsinkron) }}
                    <br>PMC Monev Data Date: {{ G_formatDateNonWIBEng(tanggaldatamonev) }}
                </p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="col-sm-4 wow fadeInUp" data-wow-delay="0.1s"
                    style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                    <DonutsChartMonitoringWaktuProyek type="donut" :options="chartOptionswaktu" :series="serieswaktu"
                        height="400">
                    </DonutsChartMonitoringWaktuProyek>
                </div>
                <div class="col-sm-4 wow fadeInUp" data-wow-delay="0.1s"
                    style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                    <DonutsChartMonitoringProyek type="donut" :options="chartOptionsproyek" :series="seriesproyek"
                        height="400">
                    </DonutsChartMonitoringProyek>
                </div>
                <div class="col-sm-4 wow fadeInUp" data-wow-delay="0.1s"
                    style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                    <DonutsChartMonitoringPVProyek type="donut" :options="chartOptionspv" :series="seriespv"
                        height="400">
                    </DonutsChartMonitoringPVProyek>
                </div>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s"
                    style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                    <LineChartMonitoringProyek type="line" :options="chartOptionsmonitoring" :series="seriesmonitoring"
                        height="500">
                    </LineChartMonitoringProyek>
                </div>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        REKAPITULASI OVERALL WORK PLAN / OWP
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        RECAPITULATION OVERALL WORK PLAN / OWP
                    </h1>
                </div>
                <p class="mb-0" v-if="(bahasa === null) || (bahasa == 'ina')">
                    Tanggal Integrasi Data (PMIS, LMS & E-mon): {{ G_formatDate(tanggalsinkron) }}
                    <br>Tanggal Data Monev PMC: {{ G_formatDateNonWIB(tanggaldatamonev) }}
                </p>
                <p class="mb-0" v-else>
                    Data Integration Date (PMIS, LMS & E-mon): {{ G_formatDateEng(tanggalsinkron) }}
                    <br>PMC Monev Data Date: {{ G_formatDateNonWIBEng(tanggaldatamonev) }}
                </p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="table-responsive table-wrapper">
                        <table class="table m-0" id="tabeldata" style="font-size: smaller !important;">
                            <thead>
                                <tr>
                                    <th style="width: 50px;">No</th>
                                    <th style="width: 350px;">PIU</th>
                                    <th style="width: 150px;">OWP (Rp. / IDR)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="total" colspan="2"> TOTAL</td>
                                    <td class="totalkanan">{{ G_numFormat(totalowp) }}</td>
                                </tr>
                            </tbody>
                            <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                <tbody>
                                    <tr>
                                        <td>
                                            {{ urutlist + 1 }}
                                        </td>
                                        <td>
                                            {{ datalist.NmSatker }}
                                        </td>
                                        <td class="text-right">
                                            {{ G_numFormat(datalist.OWP) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                            <tbody v-if="(datapesan == 'data kosong')">
                                <tr>
                                    <td colspan="3">Data masih kosong</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        REKAPITULASI ANNUAL WORK PLAN / AWP
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        RECAPITULATION ANNUAL WORK PLAN / AWP
                    </h1>
                </div>
                <p class="mb-0" v-if="(bahasa === null) || (bahasa == 'ina')">
                    Tanggal Integrasi Data (PMIS, LMS & E-mon): {{ G_formatDate(tanggalsinkron) }}
                    <br>Tanggal Data Monev PMC: {{ G_formatDateNonWIB(tanggaldatamonev) }}
                </p>
                <p class="mb-0" v-else>
                    Data Integration Date (PMIS, LMS & E-mon): {{ G_formatDateEng(tanggalsinkron) }}
                    <br>PMC Monev Data Date: {{ G_formatDateNonWIBEng(tanggaldatamonev) }}
                </p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="table-responsive table-wrapper">
                        <table class="table m-0" id="tabeldata2" style="font-size: smaller !important;">
                            <thead>
                                <tr>
                                    <th style="width: 50px;" rowspan="2">No</th>
                                    <th style="width: 100px;" rowspan="2">PIU</th>
                                    <th style="width: 100px;" rowspan="2">OWP (Rp. / IDR)</th>
                                    <th style="width: 100px;" :colspan="datatahun.length">AWP</th>
                                    <th style="width: 100px;" rowspan="2">Total<br>AWP<br>(Rp. / IDR)</th>
                                    <th style="width: 100px;" rowspan="2">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Sisa<br>Pagu<br>(Rp.)</span>
                                        <span v-else>Remaining<br>Ceiling<br>(IDR)</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        {{ listtahun.tahun }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="total" colspan="2"> TOTAL</td>
                                    <td class="totalkanan">{{ G_numFormat(totalowp) }}</td>
                                    <td class="totalkanan" v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        {{ G_numFormat(listtahun.awppertahun) }}
                                    </td>
                                    <td class="totalkanan">
                                        {{ G_numFormat(totalawp) }}
                                    </td>
                                    <td class="totalkanan">
                                        {{ G_numFormat(sisapagu) }}
                                    </td>
                                </tr>
                            </tbody>
                            <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                <tbody>
                                    <tr>
                                        <td>
                                            {{ urutlist + 1 }}
                                        </td>
                                        <td>
                                            {{ datalist.NmSatker }}
                                        </td>
                                        <td class="text-right">
                                            {{ G_numFormat(datalist.OWP) }}
                                        </td>
                                        <td class="text-right" v-for="(datalistawp, urutlistawp) in datalist.DetailAWP"
                                            :key="urutlistawp">
                                            {{ G_numFormat(datalistawp.AWP) }}
                                        </td>
                                        <td class="text-right">
                                            {{ G_numFormat(datalist.TotalAWP) }}
                                        </td>
                                        <td class="text-right">
                                            {{ G_numFormat(datalist.SisaPagu) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                            <tbody v-if="(datapesan == 'data kosong')">
                                <tr>
                                    <td colspan="3">Data masih kosong</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">&nbsp;</div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, DonutsChartMonitoringProyek: VueApexCharts
        , DonutsChartMonitoringWaktuProyek: VueApexCharts, DonutsChartMonitoringPVProyek: VueApexCharts
        , LineChartMonitoringProyek: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            datatahun: [],
            totalowp: 0,
            totalawp: 0,
            sisapagu: 0,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            project_id: process.env.VUE_APP_PROJECT_ID,
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),
            dataproyek: [],
            seriesproyek: [],
            chartOptionsproyek: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Poppins-SemiBold, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    formatter: function (value) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    },
                                },
                                value: {
                                    formatter: function (val) {
                                        return (val / 1000000000).toFixed(0).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' M';
                                    }
                                },
                                total: {
                                    formatter: function (w) {
                                        let setTotal = w.globals.seriesTotals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                        let val = (setTotal / 1000000000000).toFixed(2).replace('.', ',')
                                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' T'
                                    },
                                    show: true,
                                },
                            }
                        }
                    }
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datawaktu: [],
            serieswaktu: [],
            chartOptionswaktu: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Poppins-SemiBold, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    formatter: function (value) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    },
                                },
                                value: {
                                    formatter: function (val) {
                                        return (val / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' Bulan';
                                    }
                                },
                                total: {
                                    formatter: function (w) {
                                        let setTotal = w.globals.seriesTotals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                        let val = (setTotal / 1).toFixed(2).replace('.', ',')
                                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' Bulan'
                                    },
                                    show: true,
                                },
                            }
                        }
                    }
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datapv: [],
            seriespv: [],
            chartOptionspv: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Poppins-SemiBold, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datamonitoring: [],
            seriesmonitoring: [],
            chartOptionsmonitoring: {
                chart: {
                    width: '100%',
                    height: 450,
                    type: 'line',
                    zoom: {
                        type: 'x',
                        enabled: true,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        autoSelected: 'zoom'
                    }
                },
                colors: ['#00CED1', '#FFD700', '#9370DB', '#4682B4', '#32CD32'],
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'Average High & Low Temperature',
                    align: 'center'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: ''
                    }
                },
                yaxis: {
                    title: {
                        text: ''
                    },
                },
                legend: {
                    position: 'bottom',
                    floating: true,
                    offsetY: -10,
                    offsetX: -5,
                    show: true,
                }
            },
        };
    },
    methods: {
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-Budgeting?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataproyek = [];
                        this.seriesproyek = [];

                        this.chartOptionsproyek = {
                            labels: []
                        };
                        this.dataproyek = Response.data.content.data;
                        this.tanggalsinkron = this.dataproyek[0].TanggalSinkronisasi;
                        this.tanggaldatamonev = this.dataproyek[0].TanggalDataMonev;
                        this.datamaster = this.dataproyek[0].OWP;
                        this.datatahun = this.dataproyek[0].Tahun;
                        this.totalawp = this.dataproyek[0].AWPTOTAL;
                        this.sisapagu = this.dataproyek[0].SISAPAGUTOTAL;
                        this.totalowp = this.datamaster.reduce((a, { OWP: e }) => a + e, 0);
                        //alert(this.totalowp);
                        this.datawaktu = [];
                        this.serieswaktu = [];
                        this.chartOptionswaktu = {
                            labels: []
                        };
                        this.datawaktu = Response.data.content.data;
                        this.datapv = [];
                        this.seriespv = [];

                        this.chartOptionspv = {
                            labels: []
                        };
                        this.datapv = Response.data.content.data;
                        this.chartOptionspv.plotOptions = {
                            pie: {
                                donut: {
                                    labels: {
                                        show: true,
                                        name: {
                                            formatter: function (value) {
                                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                            },
                                        },
                                        value: {
                                            formatter: function (val) {
                                                return (val / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                            }
                                        },
                                        total: {
                                            show: true,
                                            label: this.dataproyek[0].PVStatus,
                                            color: '#111',
                                            formatter: function (w) {
                                                return ''
                                            }
                                        }
                                    }
                                }
                            }
                        };
                        //alert(JSON.stringify(this.dataproyek));
                        this.seriesproyek.push(this.dataproyek[0].Realisasi);
                        this.seriesproyek.push(this.dataproyek[0].BelumRealisasi);

                        this.serieswaktu.push(this.datawaktu[0].ElapstimeusedBulan);
                        this.serieswaktu.push(this.datawaktu[0].ElapstimeremainingBulan);
                        var datapvnya = parseFloat(this.datapv[0].PV).toFixed(2);
                        var datakurangpvnya = parseFloat(this.datapv[0].PVRemaining).toFixed(2);
                        //alert(typeof parseFloat(datapvnya));
                        this.seriespv.push(parseFloat(datapvnya));
                        this.seriespv.push(parseFloat(datakurangpvnya));
                        //alert(this.seriespv);
                        this.chartOptionspv.colors = [this.datapv[0].PVColor, '#2176e6'];
                        var texttrilliyun = '';
                        var textrealisasi = '';
                        var textjudul = '';
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            texttrilliyun = 'Dalam Triliyun (Rp.)';
                            textrealisasi = 'Realisasi';
                            textjudul = 'Perbandingan OWP, AWP dan Realisasi Kumulatif Tahunan';
                            this.chartOptionsproyek.labels.push('Sudah dicairkan');
                            this.chartOptionsproyek.labels.push('Belum dicairkan');
                            this.chartOptionsproyek.title = {
                                text: 'Realisasi Pencairan Proyek',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionswaktu.labels.push('Waktu terpakai');
                            this.chartOptionswaktu.labels.push('Waktu tersisa');
                            this.chartOptionswaktu.title = {
                                text: 'Rasio Waktu Proyek',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionspv.labels.push('Progress Variant');
                            this.chartOptionspv.labels.push('Kekurangan ke ideal');
                            this.chartOptionspv.title = {
                                text: 'Progress Variant',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };


                        }
                        else {
                            texttrilliyun = 'in Trilions (IDR)';
                            textrealisasi = 'Realization';
                            textjudul = 'Comparison of OWP, AWP and Annual Cumulative Realization';
                            this.chartOptionsproyek.labels.push('Disbursed');
                            this.chartOptionsproyek.labels.push('Undisbursed');
                            this.chartOptionsproyek.title = {
                                text: 'Realization of Project Disbursement',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionswaktu.labels.push('Elapse time');
                            this.chartOptionswaktu.labels.push('Time left');
                            this.chartOptionswaktu.title = {
                                text: 'Project Elapse Time Ratio',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionspv.labels.push('Progress Variant');
                            this.chartOptionspv.labels.push('Deviciency to ideals');
                            this.chartOptionspv.title = {
                                text: 'Progress Variant',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };
                        }

                        this.datamonitoring = [];
                        this.seriesmonitoring = [];
                        this.datamonitoring = Response.data.content.data;
                        var temptahun = [];
                        var tempowp = [];
                        var tempawp = [];
                        var tempspm = [];
                        var tempowpmonev = [];
                        var temprealisasimonev = [];
                        for (let i = 0; i < this.dataproyek[0].Tahun.length; i++) {
                            temptahun.push(this.dataproyek[0].Tahun[i].tahun);
                            tempowp.push(this.dataproyek[0].Tahun[i].owptrilyun);
                            tempawp.push(this.dataproyek[0].Tahun[i].awptrilyun);
                            tempspm.push(this.dataproyek[0].Tahun[i].spmtrilyun);
                            tempowpmonev.push(this.dataproyek[0].Tahun[i].dataowpmonevtrilyun);
                            temprealisasimonev.push(this.dataproyek[0].Tahun[i].datarealisasimonevtrilyun);
                        }

                        this.seriesmonitoring.push(
                            {
                                name: "OWP",
                                data: tempowp
                            },
                            {
                                name: "AWP",
                                data: tempawp
                            },
                            {
                                name: "SPM",
                                data: tempspm
                            },
                            {
                                name: textrealisasi,
                                data: temprealisasimonev
                            }
                        )
                        //alert(temptahun);
                        this.chartOptionsmonitoring = {
                            title: {
                                text: textjudul,
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            },
                            xaxis: {
                                categories: temptahun,
                            },
                            yaxis: {
                                title: {
                                    text: texttrilliyun
                                },
                            },
                            legend: {
                                position: 'bottom',
                                floating: true,
                                offsetY: 10,
                                offsetX: -5,
                                show: true,
                            }
                        };

                        //alert(JSON.stringify(this.chartOptionsmonitoring.xaxis));
                    }
                    else {
                        this.totalowp = 0;
                        this.datamonitoring = [];
                        this.seriesmonitoring = [];
                        this.datamaster = [];
                        this.dataproyek = [];
                        this.seriesproyek = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionsproyek = {
                            labels: []
                        };

                        this.datawaktu = [];
                        this.serieswaktu = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionswaktu = {
                            labels: []
                        };

                        this.datapv = [];
                        this.seriespv = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionspv = {
                            labels: []
                        };
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.totalowp = 0;
                this.datamaster = [];
                this.datamonitoring = [];
                this.seriesmonitoring = [];
                this.dataproyek = [];
                this.seriesproyek = [];
                this.tanggalsinkron = new Date();
                this.chartOptionsproyek = {
                    labels: []
                };

                this.datawaktu = [];
                this.serieswaktu = [];
                this.tanggalsinkron = new Date();
                this.chartOptionswaktu = {
                    labels: []
                };

                this.datapv = [];
                this.seriespv = [];
                this.tanggalsinkron = new Date();
                this.chartOptionspv = {
                    labels: []
                };
                //console.log(error);
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>